<div class="tagi-dialog">
  <div mat-dialog-content>
    <lemon-dialog-header>
      @if (onkoUusiTagi) {
        Lisää tagi
      } @else {
        Muokkaa tagia
      }
    </lemon-dialog-header>
    <form (ngSubmit)="tallenna()">
      <mat-form-field>
        <mat-label>Nimi</mat-label>
        <input matInput type="text" [formField]="lomake.nimi" />
        @if (onkoVirhe(lomake.nimi, 'required') && (lomake.nimi().dirty() || lomake.nimi().touched())) {
          <mat-error> Nimi puuttuu </mat-error>
        }
      </mat-form-field>
      <div class="vari-otsikko">Väri</div>
      <div class="vari-pallot">
        @for (vari of varit; track vari.varikoodi) {
          <span class="vari-pallo" [style.background]="vari.varikoodi" [class.valittu]="vari.varikoodi === valittuVari.varikoodi" (click)="valitseVari(vari)"></span>
        }
      </div>
      @if (!onkoUusiTagi) {
        <div class="poistettu-valinta">
          <mat-checkbox [formField]="lomake.poistettu">Poistettu (ei voi enää valita asiakkaille)</mat-checkbox>
        </div>
      }
    </form>
  </div>

  <div mat-dialog-actions class="dialog-toiminnot">
    <app-secondary-button actionId="Tagi (ylläpito): Peruuta ja sulje dialog" [focusRegionStart]="true" mat-dialog-close>Sulje</app-secondary-button>
    <app-primary-button (click)="tallenna()" actionId="Tagi (ylläpito): Tallenna" [actionContext]="[lomake().value()]">Tallenna</app-primary-button>
  </div>
</div>
